<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row mb-5">
            <div class="col-12">
                <label class="mb-4 ml-3 h5 text-uppercase">
                    Datos del responsable 1
                </label>
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Nombre del responsable" type="text" name="nombre_responsable" id="nombre_responsable" rules="required" v-model="base.nombre_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Apellidos del responsable" type="text" name="apellidos_responsable" id="apellidos_responsable" rules="required" v-model="base.apellidos_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="DNI del responsable" type="text" name="dni_responsable" id="dni_responsable" rules="" v-model="base.dni_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Teléfono del responsable" type="number" name="telefono_responsable" id="telefono_responsable" rules="required" v-model="base.telefono_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4 mb-5">
                    <FormInput style="width: 98%; margin: auto" label="Email del responsable" type="email" name="email_responsable" id="email_responsable" rules="required" v-model="base.email_responsable" :disabled="!paso_activo" />
                </div>
                <div class="col-12">
                    <label class="mb-4 h5 text-uppercase">
                        Datos del responsable 2
                    </label>    
                </div>
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Nombre del responsable 2" type="text" name="nombre_responsable_2" id="nombre_responsable_2" rules="" v-model="base.nombre_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Apellidos del responsable 2" type="text" name="apellidos_responsable_2" id="apellidos_responsable_2" rules="" v-model="base.apellidos_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="DNI del responsable 2" type="text" name="dni_responsable_2" id="dni_responsable_2" rules="" v-model="base.dni_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4">
                    <FormInput style="width: 98%; margin: auto" label="Teléfono del responsable 2" type="number" name="telefono_responsable_2" id="telefono_responsable_2" rules="" v-model="base.telefono_responsable_2" :disabled="!paso_activo" />
                </div>
                <div class="col-12 mt-4 mb-4">
                    <FormInput style="width: 98%; margin: auto" label="Email del responsable 2" type="email" name="email_responsable_2" id="email_responsable_2" rules="" v-model="base.email_responsable_2" :disabled="!paso_activo" />
                </div>
                <br />
                <div class="col-12">
                    <FormInput style="width: 98%; margin: auto" label="Observaciones" type="text" name="observaciones" id="observaciones" rules="" v-model="base.observaciones" :disabled="!paso_activo" />
                </div>
                <div class="col-12 text-right mt-4">
                    <Button @click="volver()" name="button" class="mr-2" :disabled="!paso_activo">ATRÁS</Button>
                    <Button id="terminar-paso-2" type="submit" name="button" :disabled="!paso_activo">CONTINUAR</Button>
                </div>
            </div>
        </div>
    </ValidationObserver>    
</template>

<script>
export default {
    props: ["base", "paso_activo"],
    data() {
        return {};
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        terminar() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                this.base.session_id = res.data.session_id;
            });

            this.$emit('terminado');
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.terminar();
            }
        },
        volver() {
            this.$emit('volver');
        }
    }
};
</script>